
export const PROJECT_INVESTMENT_INFO_ITEM_MODAL_BUTTON_TYPE = {
    DETAIL: 'detail',
    PRIMARY: 'primary',
    LINK_DATA: 'link_data',
} as const;

export const PROJECT_INVESTMENT_INFO_ITEM_MODAL_TAB_KEYS = {
    MAIN: 'main',
    TARGET_INDICATORS: 'target_indicators',
    FINANCIAL_INDICATORS: 'financial_indicators',
    INVESTORS: 'investors',
    FINANCIAL_SOURCE: 'financial_SOURCE',
} as const;

export const BINARY_VALUES = {
    YES: '1',
    NO: '0',
};

export const INVEST_PROJECT_STATUS_CODE_REQUIRED = ['4', '5', '6'];
export const INVEST_PROJECT_STATUS_PLANNING_CODE = '1';
export const INVEST_PROJECT_STATUS_IMPLEMENTED_CODE = '3';
export const BENEFIT_GOV_SUPPORT_OTHER_CODE = '21';
export const DOCUMENT_BASE_GOV_SUPPORT_OTHER_CODE = '11';
export const FIN_SOURCE_TYPE_CODES_FOR_INN = ['1', '2', '4', '6'];
export const FIN_SOURCE_TYPE_CODES_FOR_REG_NUM = ['3', '5', '7'];

export const DELETE_INVEST_PROJECT_CONFIRM_TEXT =
    'Вы уверены, что хотите удалить выбранные записи о проектах?';

export const DELETE_INVEST_PROJECT_WARN_TEXT =
    'Невозможно удалить выбранные записи о проектах, так как среди них есть проставленные признаки "Активный".';
